import {getReviews} from '../api/reviews';
import {getTranslatedReviews} from '../api/translateReviews';
import ReviewsActions from '../actions/reviewsActions';
import RouterActions from '../actions/routerActions';
import EdapActions from '../actions/edapActions';
import {availableRoutes} from '../routes';

function nextPage(store) {
    const state = store.getState();
    const {systemReducer, listingReducer, reviewsReducer} = state;

    const pageSize = systemReducer.reviewPageSize;

    const reviewsData = reviewsReducer.toJS();
    const reviews = reviewsData.reviews;
    const filter = reviewsData.filter;
    const totalReviewCount = reviewsData.reviewCount;
    const nextPageNumber = reviewsData.pageIndex + 1;

    if (nextPageNumber * pageSize <= reviews.length || reviews.length === totalReviewCount) {
        store.dispatch(ReviewsActions.setPageIndex(nextPageNumber));
        return Promise.resolve({});
    }

    store.dispatch(ReviewsActions.fetchReviewsStarted());

    return getReviews({
        listingId: listingReducer.listingId,
        filter,
        site: systemReducer.siteName,
        page: nextPageNumber,
        pageSize
    })
        .then((response) => {
            store.dispatch(ReviewsActions.scrollTop(false));
            store.dispatch(ReviewsActions.fetchReviewsSuccess(response.body, state.filter));
            store.dispatch(ReviewsActions.setPageIndex(response.body.paging.page));
        })
        .catch((error) => {
            store.dispatch(ReviewsActions.scrollTop(false));
            store.dispatch(ReviewsActions.fetchReviewsFailure(error));
        });
}

function translateReviews(store) {
    const state = store.getState();
    const {reviewsReducer} = state;

    const reviewsData = reviewsReducer.toJS();

    store.dispatch(ReviewsActions.fetchReviewsStarted());

    return getTranslatedReviews({
        reviews: reviewsData.reviews
    })
        .then((response) => {
            store.dispatch(ReviewsActions.scrollTop(false));
            store.dispatch(ReviewsActions.translateReviewsSuccess(response.body));
            store.dispatch(ReviewsActions.hideTranslationButton(false));
        })
        .catch((error) => {
            store.dispatch(ReviewsActions.scrollTop(false));
            store.dispatch(ReviewsActions.fetchReviewsFailure(error));
        });
}

function previousPage(store) {
    const state = store.getState();
    const page = state.reviewsReducer.pageIndex;

    if (page > 1) {
        store.dispatch(ReviewsActions.setPageIndex(page - 1));
    }
}

function viewAllReviews(store, action = {payload: {}}) {
    const {uuid} = action.payload;
    const {systemReducer} = store.getState();
    const reviewId = typeof uuid === 'string' && uuid.length > 0 ? uuid : '';

    store.dispatch(ReviewsActions.expandReviewClicked(reviewId));
    store.dispatch(
        RouterActions.navigateTo(`${systemReducer.baseUrlPath}?r=${availableRoutes.INQUIRY}`)
    );
    store.dispatch(
        EdapActions.triggerEdapEvent('generic.modal', {
            modalname: 'reviews',
            modalaction: 'open'
        })
    );
}

function generateFilter(ratingArray, filter) {
    // Some user events do not pass ratingArray as they are not interacting
    // with the the star rating filters, thus use the state filter passed in instead
    if (!ratingArray) {
        return filter;
    }
    return ratingArray
        .reduce((parameters, rating) => {
            if (rating > -1) {
                parameters.push(`filterBy=Rating.${rating}`);
            }

            return parameters;
        }, [])
        .join('&');
}

export default {generateFilter, viewAllReviews, nextPage, previousPage, translateReviews};
export {generateFilter, viewAllReviews, nextPage, previousPage, translateReviews};
